module.exports = {
    carePackage: {
        cartConfirmationModalTitle: 'Heads up!<br/>If you add a Woolworths Basics Box to your cart, we’ll automatically remove all other items in your cart.',
        cartConfirmationModalContent: 'This is because Woolworths Basics Boxes are delivered by Australia Post, so we are unable to add any additional items to your order.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/care-package.js